import English from "../languages/en";
import Polish from "../languages/pl";

export const PL_language = {
  lang: Polish,
  locale: "pl",
};
export const EN_language = {
  lang: English,
  locale: "en",
};
